import { render, staticRenderFns } from "./TwitterAlert.vue?vue&type=template&id=385336de&"
import script from "./TwitterAlert.vue?vue&type=script&lang=js&"
export * from "./TwitterAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
